var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12C9.3 12 12 9.3 12 6C12 2.7 9.3 0 6 0ZM6 9.75C5.55 9.75 5.25 9.45 5.25 9C5.25 8.55 5.55 8.25 6 8.25C6.45 8.25 6.75 8.55 6.75 9C6.75 9.45 6.45 9.75 6 9.75ZM7.125 6.3C6.75 6.525 6.75 6.6 6.75 6.75V7.5H5.25V6.75C5.25 5.775 5.85 5.325 6.3 5.025C6.675 4.8 6.75 4.725 6.75 4.5C6.75 4.05 6.45 3.75 6 3.75C5.7 3.75 5.475 3.9 5.325 4.125L4.95 4.8L3.675 4.05L4.05 3.375C4.425 2.7 5.175 2.25 6 2.25C7.275 2.25 8.25 3.225 8.25 4.5C8.25 5.55 7.575 6 7.125 6.3Z",
    fill: "#B1B5B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.14b9cd4ddcb60c09c12b7291701bec52.svg";
export { ForwardRef as ReactComponent };